import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { UIdModel } from '../../models/uid-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-scan-barcode-modal',
  templateUrl: './scan-barcode-modal.component.html',
  styleUrls: ['./scan-barcode-modal.component.css'],
})
export class ScanBarcodeModalComponent implements OnChanges {
  @Input() itemCount?: number;
  @Input() drugName?: string;
  public ActiveAddButton: boolean = false;
  @Input() barcodeList: UIdModel[] = [];
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  constructor(private logger:LoggerService) {
    if (this.itemCount == null || this.itemCount == 0) {
      this.itemCount = 1;
      this.ActiveAddButton = true;
    } else if (this.itemCount > 0) {
      this.ActiveAddButton = false;
    }
  }

  public modalSuccessConfirm: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['itemCount'] &&
      changes['itemCount'].currentValue !== undefined
    ) {
      const newData = changes['itemCount'].currentValue;

      if (newData == null || newData <= 0) {
        this.ActiveAddButton = true;
      } else {
        this.ActiveAddButton = false;
      }

      this.setArrayList();
    }
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
    }
  }

  public callParent(method: string, data: any) {
    this.parentActionOutput.emit(new PCTableOutputModel(method, data));
  }

  public setArrayList() {
    if (this.itemCount == null || this.itemCount == 0) {
      this.itemCount = 1;
    }

    if (this.barcodeList == null) {
      this.barcodeList = [];
    }

    if (this.barcodeList.length == this.itemCount) {
      return;
    }

    const loopRepeatNeed=this.itemCount-this.barcodeList.length;
    for (let index = 0; index < loopRepeatNeed; index++) {
      this.barcodeList.push(new UIdModel(''));
    }
  }

  public addNewBarcode() {
    if (this.barcodeList == null) {
      this.barcodeList = [];
    }
    this.callParent('SaveUid',this.barcodeList);
    this.barcodeList.push(new UIdModel(''));
  }

  public saveBarcode(){
    this.callParent('SaveUid',this.barcodeList)
  }
}
